import { FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_CONDUCTORS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/startingActions/conductors';
import { FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_DETAILS_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/startingActions/details';
import { FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_SOURCES_OF_FUNDS_OR_VIRTUAL_CURRENCY_FIELDS } from 'app/modules/fintracStr/formConfig/transactions/startingActions/sourcesOfFundsOrVirtualCurrency';
import { FintracFormSingleField } from 'app/modules/fintracStr/models';

export const FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_FIELDS: FintracFormSingleField =
  {
    type: 'section',
    repeatable: true,
    label: 'Starting Actions',
    name: 'startingActions',
    mustExistInPayload: true,
    mustHaveValueIfExist: false,
    maxRepeat: 50,
    fields: [
      FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_DETAILS_FIELDS,
      FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_SOURCES_OF_FUNDS_OR_VIRTUAL_CURRENCY_FIELDS,
      FINTRAC_STR_TRANSACTION_STARTING_ACTIONS_CONDUCTORS_FIELDS,
    ],
  };
